import Category from 'types/category';

export type CategoryAccountNumberUpdate = {
  categoryId: string;
  accountNumber: string;
};

function parentIdOf(category: Category): string | null {
  if (!category.parent) {
    return null;
  }
  return typeof category.parent === 'string'
    ? category.parent
    : category.parent.id;
}

export function getDirectChildCategories(
  categories: Record<string, Category>,
  parentId: string | null,
): Category[] {
  return Object.values(categories).filter((category) => {
    if (category.isVoided) {
      return false;
    }
    return parentIdOf(category) === parentId;
  });
}
